const { connect } = require('react-redux');
const gameClearComponent = require('../component/gameClearComponent').default;
const { actions } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    const { screenState, playerState, gameState, appState } = state;
    return {
        isModalOpen: screenState.modal === modalType.MODAL_GAME_CLEAR,
        soundEnable: appState.soundEnable,
        playerState,
        gameState
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleTitleClick: () => {
            dispatch(actions.modalDisable());
            dispatch(actions.modalEnable(modalType.MODAL_RESULT));
        }
    };
};

export const GameClearContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(gameClearComponent);